export const SCROLL_DIRECTION = {
  DOWN: 1,
  UP: -1,
  STATIC: 0,
};

export const SCROLL_BEHAVIOR = {
  DOWN: 'DOWN',
  UP: 'UP',
  OSCILLATE: 'OSCILLATE',
  STATIC: 'STATIC',
};
